import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#FFDA44\" d=\"M20.1 3.146A11.96 11.96 0 0 0 12 0q-.769 0-1.51.094L4.695 6.782.379 15.005a12 12 0 0 0 1.255 3.043L11.999 12z\"></path><path fill=\"#6DA544\" d=\"m21.992 18.648-16.789 3.24a11.94 11.94 0 0 0 6.799 2.111c4.168 0 7.84-2.125 9.99-5.351\"></path><path fill=\"#D80027\" d=\"M20.101 3.148 1.641 18.06a12 12 0 0 0 1.72 2.268L23.998 12c0-3.505-1.502-6.658-3.898-8.852\"></path><path fill=\"#0052B4\" d=\"M0 12c0 1.038.132 2.046.38 3.006L10.49.094C4.577.836 0 5.884 0 12\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }